<template>
  <div id="app">
    <keep-alive include="mainPage,withdrawal">
      <router-view/>
    </keep-alive>
    <navbar />
  </div>
</template>

<script>
// import navbar from '@/view/navbar'
import navbar from '@/view/navbar'

export default {
  name: 'App',
  components: {
    navbar
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* color: #2c3e50; */
  color:#41496B;
  font-size: 14px;
  min-height: 100vh;
  background: #fff;
  padding-bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue